<template>
  <div class="table-container pull-auto">
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @search-change="searchChange"
                 @row-del="rowDel">
        <template slot-scope="scope"
                  slot="type">
          <el-tag size="mini" :type="scope.row.type==0?'success':'danger'">{{findByvalue(scope.dic,scope.row.type)}}</el-tag>
        </template>

        <template slot-scope="scope"
                  slot="menu">
          <el-button type="danger"
                     v-if="permissions.sys_log_del"
                     icon="el-icon-delete"
                     size="mini"
                     plain
                     @click="handleDel(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
  </div>
</template>

<script>
  import { fetchList, delObj } from '@/api/admin/log'
  import { tableOption } from '@/const/crud/log'
  import { mapGetters } from 'vuex'
  export default {
    name: 'log',
    data() {
      return {
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 20,
          delFlag: 0,
          type: undefined,
          requestUri: undefined,
          remoteAddr: undefined
        },
        tableLoading: false,
        tableOption: tableOption
      }
    },
    created() {
      this.getList()
    },
    mounted: function() {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      /**
       * @title 获取字典
       * @detail 调用crud的findByvalue方法即可
       *
       **/
      findByvalue (dic, value) {
        return this.$refs.crud.findByvalue(dic, value);
      },
      getList() {
        this.tableLoading = true
        this.listQuery.descs = 'create_time'
        this.listQuery.isAsc = false
        fetchList(this.listQuery).then(response => {
          this.tableData = response.data.data.records
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      currentChange(val) {
        this.listQuery.current = val
        this.getList()
      },
      sizeChange(val) {
        this.listQuery.size = val
        this.getList()
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      rowDel: function(row) {
        var _this = this
        this.$confirm('是否确认删除ID为"' + row.remoteAddr + '"的日志?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function() {
            return delObj(row.id)
          }).then(data => {
            this.getList()
            if(data.status == 200){
              _this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success'
              })
            }

          })
          .catch(function(err) {
            return err;
          })
      },
      /**
       * 搜索回调
       */
      searchChange(form) {
        this.listQuery.type = form.type
        this.listQuery.requestUri = form.requestUri
        this.listQuery.remoteAddr = form.remoteAddr
        this.getList()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .avue-crud /deep/ .avue-crud__menu{
    min-height: auto !important;
    margin-bottom: 0px !important;
  }
</style>

